import { ConfirmSolid, Eye, EyeSlash } from '@icons';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

type ResetPasswordFormType = {
	password: string;
	passwordConfirmation: string;
};

interface PasswordResetProps {
	// validConditions: {
	// 	length: boolean;
	// 	uppercase: boolean;
	// 	number: boolean;
	// 	specialChar: boolean;
	// };
	resetPasswordForm: ResetPasswordFormType;
	setResetPasswordForm: React.Dispatch<React.SetStateAction<ResetPasswordFormType>>;
	handleResetPassword: () => void;
}

const PasswordReset: React.FC<PasswordResetProps> = ({ resetPasswordForm, setResetPasswordForm, handleResetPassword }) => {
	const validationMap: { [key: string]: { isValid: (value: string) => boolean; label: string } } = {
		length: {
			isValid: (value) => value.length >= 10,
			label: 'Contenere almeno 10 caratteri',
		},
		uppercase: {
			isValid: (value) => /[A-Z]/.test(value),
			label: 'Contenere almeno una lettera maiuscola',
		},
		number: {
			isValid: (value) => /\d/.test(value),
			label: 'Contenere almeno un numero',
		},
		specialChar: {
			isValid: (value) => /[!@#$%^&*(),.?":{}|<>]/.test(value),
			label: 'Contenere almeno un carattere speciale',
		},
	};

	// const [password, setPassword] = useState('');
	// const [passwordConfirmation, setPasswordConfirmation] = useState('');

	const [validConditions, setValidConditions] = useState({
		length: false,
		uppercase: false,
		number: false,
		specialChar: false,
	});

	const [hiddenFields, setHiddenFields] = useState({
		password: true,
		passwordConfirmation: true,
	});

	return (
		<div>
			<h5
				style={{
					fontSize: '32px',
					fontWeight: 700,
					lineHeight: '28.8px',
				}}
				className="pb-3"
			>
				Reimposta la password
			</h5>
			<p>Per una password sicura, devi usare almeno 10 caratteri, includendo almeno una maiuscola, un numero e un carattere speciale.</p>

			<div
				style={{
					display: 'grid',
					gap: '1rem',
					marginBottom: '1.5rem',
				}}
			>
				<Form.Group
					style={{
						position: 'relative',
					}}
				>
					<Form.Label>Nuova Password</Form.Label>
					<Form.Control
						autoComplete="new-password"
						type={hiddenFields.password ? 'password' : 'text'}
						placeholder="Inserisci la nuova password"
						onChange={(event) => {
							setValidConditions({
								length: validationMap.length.isValid(event.target.value),
								uppercase: validationMap.uppercase.isValid(event.target.value),
								number: validationMap.number.isValid(event.target.value),
								specialChar: validationMap.specialChar.isValid(event.target.value),
							});
							setResetPasswordForm({ ...resetPasswordForm, password: event.target.value });
						}}
					/>
					<Button
						aria-label={hiddenFields.password ? 'Mostra password' : 'Nascondi password'}
						onClick={() => {
							setHiddenFields({ ...hiddenFields, password: !hiddenFields.password });
						}}
						className="btn custom-ghost-button"
						style={{
							color: 'var(--np-text-primary-color)',
							position: 'absolute',
							right: 0,
							top: '2rem',
						}}
					>
						{hiddenFields.password ? <Eye className="eye" /> : <EyeSlash className="eye" />}
					</Button>
				</Form.Group>
				<Form.Group style={{ position: 'relative' }}>
					<Form.Label>Conferma Nuova Password</Form.Label>
					<Form.Control
						autoComplete="new-password"
						type={hiddenFields.passwordConfirmation ? 'password' : 'text'}
						placeholder="Conferma la nuova password"
						onChange={(event) => setResetPasswordForm({ ...resetPasswordForm, passwordConfirmation: event.target.value })}
					/>
					<Button
						aria-label={hiddenFields.passwordConfirmation ? 'Mostra password' : 'Nascondi password'}
						onClick={() => {
							setHiddenFields({ ...hiddenFields, passwordConfirmation: !hiddenFields.passwordConfirmation });
						}}
						className="btn custom-ghost-button"
						style={{
							color: 'var(--np-text-primary-color)',
							position: 'absolute',
							right: 0,
							top: '2rem',
						}}
					>
						{hiddenFields.password ? <Eye className="eye" /> : <EyeSlash className="eye" />}
					</Button>
				</Form.Group>
			</div>

			<div
				// sm={3}
				style={{
					backgroundColor: '#E3E7EB',
					borderRadius: '8px',
					padding: '24px',
					marginLeft: 'calc(var(--bs-gutter-x) * 0.5)',
					marginBottom: '1.5rem',
				}}
			>
				<p style={{ fontWeight: 700 }}>La password deve:</p>
				<ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
					{Object.entries(validationMap).map(([key, { label }]) => (
						<li key={key} style={{ marginBottom: '4px' }}>
							{!validConditions[key] ? (
								<span
									style={{
										// backgroundColor: '#1C2743',
										backgroundColor: 'var(--np-primary-color)',
										borderRadius: '100%',
										width: '16px',
										height: '16px',
										display: 'inline-block',
										marginRight: '8px',
									}}
								/>
							) : (
								<ConfirmSolid
									style={{
										width: '16px',
										height: '16px',
										marginRight: '8px',
									}}
								/>
							)}
							{label}
						</li>
					))}
				</ul>
			</div>

			<Button
				onClick={handleResetPassword}
				disabled={Object.values(validConditions).includes(false) || resetPasswordForm.password !== resetPasswordForm.passwordConfirmation}
				className="btn custom-primary-button"
				style={{ width: '100%' }}
			>
				Reimposta
			</Button>
		</div>
	);
};

export default PasswordReset;
